import type { GridColDef } from '@mui/x-data-grid';
import type { CustomerOverview } from '@weft/api-definition';
import type { CustomerStatus } from '@weft/types';
import { CUSTOMER_STATUSES } from '@weft/types';
import type { FieldPath } from 'react-hook-form';
import { Price } from '../../../../components/design/Price';
import { Status } from '../../../../components/design/statuses/Status/Status';
import type { StatusType } from '../../../../components/design/statuses/Status/status-types/status-types';

export const CUSTOMERS_COLUMNS_KEYS = Object.freeze({
  STATUS: 'status',
  NAME: 'name',
  REVENUE: 'revenue',
  ACCRUED: 'contractsCount',
  CREATED_AT: 'createdAt',
} satisfies Record<string, FieldPath<CustomerOverview>>);

export const CUSTOMERS_COLUMNS: GridColDef<CustomerOverview>[] = [
  {
    field: CUSTOMERS_COLUMNS_KEYS.STATUS,
    headerName: 'Status',
    flex: 1,
    headerClassName: 'pl-6',
    cellClassName: 'pl-6',
    renderCell: ({ row }) => {
      const mappedStatuses: Record<CustomerStatus, StatusType> = {
        [CUSTOMER_STATUSES.Active]: 'SUCCESS',
        [CUSTOMER_STATUSES.Suspended]: 'WARNING',
        [CUSTOMER_STATUSES.Inactive]: 'NEUTRAL',
      };

      return (
        <Status status={mappedStatuses[row.status]}>
          {row.status}
        </Status>
      );
    },
  },
  {
    field: CUSTOMERS_COLUMNS_KEYS.NAME,
    headerName: 'Customer',
    flex: 2,
    renderCell: ({ row }) => (
      <span className="font-sans text-black">
        {row.name}
      </span>
    ),
  },
  {
    field: CUSTOMERS_COLUMNS_KEYS.REVENUE,
    headerName: 'Revenue',
    flex: 1,
    renderCell: ({ row }) => (
      <Price
        className="font-sans text-black"
        currency={row.currency}
      >
        {row.revenue}
      </Price>
    ),
  },
  {
    field: CUSTOMERS_COLUMNS_KEYS.ACCRUED,
    headerName: 'Contracts Assigned',
    flex: 1,
    renderCell: ({ row }) => (
      <span className="font-sans text-black">
        {row.contractsCount}
      </span>
    ),
  },
];
